module.exports = __webpack_public_path__ + "img/naics-tree_example_en.d34d0ece.jpg";